/**
 * "Skip for now" on the two doors, remembered per workspace on this device.
 *
 * A convenience, never state that must hold: storage can be missing (a private
 * window, blocked site data), and then the doors simply show again on the next
 * sign-in. Every read and write is wrapped so a throwing accessor never breaks
 * the shell.
 */

const KEY_PREFIX = "yagni.welcome.skipped.";

export function welcomeSkipKey(workspaceId: string): string {
  return `${KEY_PREFIX}${workspaceId}`;
}

export function hasSkippedWelcome(workspaceId: string): boolean {
  try {
    return window.localStorage.getItem(welcomeSkipKey(workspaceId)) === "1";
  } catch {
    return false;
  }
}

export function rememberWelcomeSkip(workspaceId: string): void {
  try {
    window.localStorage.setItem(welcomeSkipKey(workspaceId), "1");
  } catch {
    // storage unavailable: the doors show again next sign-in, which is honest
  }
}
